<div
    [class.menu-header-activated]="isMenuHeaderFFActivated()"
    [ngStyle]="{
        '--header-height-mobile.px': HEADER_MOBILE_HEIGHT,
        '--header-height-desktop.px': HEADER_DESKTOP_HEIGHT,
        '--header-height-desktop-with-menu.px': HEADER_DESKTOP_HEIGHT_WITH_MENU,
        '--header-height-desktop-with-skip-links.px': HEADER_DESKTOP_HEIGHT_WITH_SKIP_LINKS,
    }"
    ><ng-content></ng-content>
</div>
